module.exports = __webpack_public_path__ + "a5a6eca1ef548a038b83aa3564ed281c.svg";